export default class EmailListingsModel {
  constructor(
    public EmailId: number = 0,
    public EmailAddress: string = '',
    public SenderName: string = '',
    public IsApplied: boolean = true,
    public IsActive: boolean = true,
  ){}

  public static createEmpty(): EmailListingsModel{
    return new EmailListingsModel();
  }
}
